/* eslint-disable react-hooks/exhaustive-deps */
import { OverlaysProvider } from "@blueprintjs/core"
import { useEffect } from "react"
import { DIALOG_SIZE, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { ILanding } from "../../data/interfaces"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "../../data/store"
import { getLandingContainer } from "../utils/getLandingContainer"

/* Protopia Ecosystem component */
export interface ILandingContainerProps {
   children: JSX.Element | JSX.Element[]
   className?: string
   className2?: string
   isEdit: boolean
}
const LandingContainer = (props: ILandingContainerProps): JSX.Element => {
    const currentLanding:ILanding = useLandingStore((state: ILandingStore) => state.currentLanding) 
    
    useEffect(() => useLandingConsoleStore.subscribe(
        (state: ILandingConsoleStore) => {  
            // TODO::без таймаута не срабатывает при первой загрузке.
            setTimeout(() => {
                const lSections         = document.querySelectorAll(".landing-section,.landing-edit-section-hidden") 
                const panelLayout: any  = document.querySelector(".pe-panel-layout-container") 
                const pw                = panelLayout?.getBoundingClientRect() || {}
                
                if( state.currentDimensionEdit >= WINDOW_WIDTH.PANEL && pw.width > 132 ) {            
                    lSections.forEach((ls: any) => {
                        ls.style.width = "100%" 
                    })
                    if( panelLayout ) {
                        panelLayout.style.position  = "absolute"
                        panelLayout.style.right     = "0px" 
                    }   
                }
                else { 
                    lSections.forEach((ls: any) => {
                        ls.style.width = state.currentDimensionEdit + "px"
                        ls.style.margin = "0 auto"
                        ls.style.borderLeft = "1px dotted var(--force-contrast-opacity-color)"
                        ls.style.borderRight = "1px dotted var(--force-contrast-opacity-color)"
                    })
                    if( panelLayout ) {
                        delete panelLayout?.style.position
                    }
                }
            }, 100) 
        }
    ), []) 

    useEffect(() => {         
        if( !props.isEdit ) return
        document.getElementsByTagName("body")[0].classList.add("landing-is-edit")
        const landingContainer = getLandingContainer() as HTMLDivElement
        useLandingStore.setState({ 
            isEdit:         true,
            landingRect:    landingContainer.getBoundingClientRect()
        })
        const resizeObserver = new ResizeObserver((entries, observer) => {
            entries.forEach((entry) => { 
                useLandingStore.setState({ landingRect: entry.target.getBoundingClientRect() })  
            });
        });
        resizeObserver.observe( landingContainer )  
        return () => { 
            resizeObserver.unobserve( landingContainer )
            useLandingStore.setState({ isEdit: false })
            document.getElementsByTagName("body")[0].classList.remove("landing-is-edit") 
        }
    }, [])

    const containerClassName = () => {
        switch(currentLanding.size) {
            case DIALOG_SIZE.NORMAL: return "container"
            case DIALOG_SIZE.LITTLE: return "small-container"
            case DIALOG_SIZE.FULL:
            case DIALOG_SIZE.LARGE: 
            default:
                return "landing-container-fluid container-fluid"
        }
    }
    
    return <div className={`landing-background main-landing ${props.className || ""}`}>
        <div className={`landing-container section-gap pe-full-screen-scroll-wrapper overflow-y-auto ${containerClassName()} ${props.className2}`} >
            <OverlaysProvider>
                {props.children}
            </OverlaysProvider>
        </div>
    </div>
}
export default LandingContainer